import React from 'react';
import './ExpandingLoader.scss';

const delays = ['0.3s', '0s', '0.2s', '0.1s', '0.4s', '0.05s', '0.25s'];

const ExpandingLoader = () => {
  return (
    <div className="expanding-loader">
      {delays.map((delay, i) => (
        <div key={i} className="bar" style={{ animationDelay: delay }}>
          <div className="dot top" />
          <div className="line" style={{ animationDelay: delay }} />
          <div className="dot bottom" />
        </div>
      ))}
    </div>
  );
};

export default ExpandingLoader;
